import { parse, pipe, transform, unknown } from 'valibot';
import {
  ArticleSeoSchema,
  NoindexSeoSchema,
  RecipeArchiveSeoSchema,
  RecipeSeoSchema,
  SeoSchema,
} from '../model/schemas';
import { createArticleSeo, createManualSeo, createRecipeSeo, createSeo } from './utils';
import { isNoindexRobots } from '../utils/isNoindexRobots';

export const PageSeoInputSchema = pipe(
  unknown(),
  transform((input) => createSeo(input)),
  transform((seo) => validateSeoByRobots(seo, SeoSchema)),
);

export const ArticleSeoInputSchema = pipe(
  unknown(),
  transform((input) => createArticleSeo(input)),
  transform((seo) => validateSeoByRobots(seo, ArticleSeoSchema)),
);

export const RecipeSeoInputSchema = pipe(
  unknown(),
  transform((input) => createRecipeSeo(input)),
  transform((seo) => validateSeoByRobots(seo, RecipeSeoSchema)),
);

export const RecipeArchiveSeoInputSchema = pipe(
  unknown(),
  transform((input) => createRecipeSeo(input)),
  transform((seo) => validateSeoByRobots(seo, RecipeArchiveSeoSchema)),
);

export const ManualSeoInputSchema = pipe(
  unknown(),
  transform((input) => createManualSeo(input)),
  transform((seo) => validateSeoByRobots(seo, SeoSchema)),
);

function validateSeoByRobots(
  seo: ReturnType<typeof createSeo>,
  indexedSchema: Parameters<typeof parse>[0],
) {
  const schema = isNoindexRobots(seo.robots) ? NoindexSeoSchema : indexedSchema;
  parse(schema, seo);
  return seo;
}
